export const transformDataForFilters = (data, defaultValue) => {
  const defaultData = {
    label: defaultValue,
    id: defaultValue,
  }
  const transformedData = data.richText.map((el) => ({
    label: el.text,
    id: el.text,
  }))
  return [defaultData, ...transformedData]
}

export const transformDataForFiltersRichText = (data) => {
  return data.richText.map((el) => ({
    label: el,
    id: el.text,
  }))
}

export const transformDataForFilterFromArray = (data) => {
  return data.map((el) => ({
    label: el,
    id: el,
  }))
}
